import type { SVGProps } from 'react';
const DawnFlagMT = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-MT_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-MT_svg__a)">
      <path
        fill="#DE233C"
        fillRule="evenodd"
        d="M11.523 16H22V0H11.523z"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-MT_svg__b"
        width={5}
        height={5}
        x={1.096}
        y={1.133}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M1.096 1.133h5v5h-5z" />
        <path
          fillRule="evenodd"
          d="M4.19 2.133H3.144V3.2H2.096v1.067h1.047v1.066h1.048V4.267h1.048V3.2H4.19z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#CCCCCD"
        fillRule="evenodd"
        d="M4.19 2.133H3.144V3.2H2.096v1.067h1.047v1.066h1.048V4.267h1.048V3.2H4.19z"
        clipRule="evenodd"
      />
      <path
        fill="#7B716A"
        fillOpacity={0.66}
        d="M3.143 2.133v-.666h-.666v.666zm1.048 0h.667v-.666H4.19zM3.143 3.2v.667h.667V3.2zm-1.047 0v-.667h-.667V3.2zm0 1.067h-.667v.666h.667zm1.047 0h.667V3.6h-.667zm0 1.066h-.666V6h.666zm1.048 0V6h.667v-.667zm0-1.066V3.6h-.667v.667zm1.048 0v.666h.666v-.666zm0-1.067h.666v-.667H5.24zm-1.048 0h-.667v.667h.667zm-1.048-.4h1.048V1.467H3.143zm.667.4V2.133H2.477V3.2zm-1.714.667h1.047V2.533H2.096zm.666.4V3.2H1.43v1.067zm.381-.667H2.096v1.333h1.047zm.667 1.733V4.267H2.477v1.066zm.38-.666H3.144V6h1.048zm-.666-.4v1.066h1.334V4.267zM5.24 3.6H4.19v1.333h1.048zm-.667-.4v1.067h1.333V3.2zm-.381.667h1.048V2.533H4.19zm-.667-1.734V3.2h1.334V2.133z"
        mask="url(#dawn-flag-MT_svg__b)"
      />
      <path
        fill="#7B716A"
        fillRule="evenodd"
        d="M3.666 4.267c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.523.533c0 .295.234.534.523.534"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagMT;
